import  {eXcell,__extends} from './eXcell';
import {dhtmlxCalendarObject} from '../../components/dhtmlXCalendar';
import goingEvent from '../../global/goingEvent';
import {dhx4} from '../../global/dhx4OrDhx';

var eXcell_dhxCalendar = (function (_super) {
    __extends(eXcell_dhxCalendar, _super);
    function eXcell_dhxCalendar(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
            if (!this.grid._grid_calendarA) {
                var e = (this.grid._grid_calendarA = new dhtmlxCalendarObject());
                this.grid.callEvent("onDhxCalendarCreated", [e]);
                var c = this.grid;
                e.attachEvent("onClick", function () {

                    this._last_operation_calendar = true;
                    window.setTimeout(function () {
                        c.editStop();
                    }, 1);
                    return true;
                });
                var g = function (h) {
                    (h || event).cancelBubble = true;
                };
                goingEvent(e.base, "click", g);
                e = null;
            }
        }
    }
    eXcell_dhxCalendar.prototype.edit = function () {
        var c = this.grid.getPosition(this.cell);
        this.grid._grid_calendarA._show(false, false);
        this.grid._grid_calendarA.setPosition(c[0], c[1] + this.cell.offsetHeight);
        this.grid._grid_calendarA._last_operation_calendar = false;
        this.grid.callEvent("onCalendarShow", [
            this.grid._grid_calendarA,
            this.cell.parentNode.idd,
            this.cell._cellIndex
        ]);
        this.cell._cediton = true;
        this.val = this.cell.val;
        this._val = this.cell.innerHTML;
        var a = this.grid._grid_calendarA.draw;
        this.grid._grid_calendarA.draw = function () { };
        this.grid._grid_calendarA.setDateFormat(this.grid._dtmask || "%d/%m/%Y");
        this.grid._grid_calendarA.setDate(this.val || new Date());
        this.grid._grid_calendarA.draw = a;
    };
    eXcell_dhxCalendar.prototype.getDate = function () {
        if (this.cell.val) {
            return this.cell.val;
        }
        return null;
    };
    eXcell_dhxCalendar.prototype.getValue = function () {
        if (this.cell._clearCell) {
            return "";
        }
        if (this.grid._dtmask_inc && this.cell.val) {
            return this.grid._grid_calendarA
                .getFormatedDate(this.grid._dtmask_inc, this.cell.val)
                .toString();
        }
        return this.cell.innerHTML.toString()._dhx_trim();
    };
    eXcell_dhxCalendar.prototype.detach = function () {
        if (!this.grid._grid_calendarA) {
            return;
        }
        this.grid._grid_calendarA.hide();
        if (this.cell._cediton) {
            this.cell._cediton = false;
        }
        else {
            return;
        }
        if (this.grid._grid_calendarA._last_operation_calendar) {
            var e = this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask || "%d/%m/%Y");
            var c = this.grid._grid_calendarA.getDate();
            this.cell.val = new Date(c);
            this.setCValue(e, c);
            this.cell._clearCell = !e;
            var a = this.val;
            this.val = this._val;
            return this.cell.val.valueOf() != (a || "").valueOf();
        }
        return false;
    };
    eXcell_dhxCalendar.prototype.setValue = function (a) {
        if (a && typeof a == "object") {
            this.cell.val = a;
            this.cell._clearCell = false;
            this.setCValue(this.grid._grid_calendarA
                .getFormatedDate(this.grid._dtmask || "%d/%m/%Y", a)
                .toString(), this.cell.val);
            return;
        }
        if (!a || a.toString()._dhx_trim() == "") {
            a = "&nbsp";
            this.cell._clearCell = true;
            this.cell.val = "";
        }
        else {
            this.cell._clearCell = false;
            this.cell.val = new Date(this.grid._grid_calendarA.setFormatedDate(this.grid._dtmask_inc || this.grid._dtmask || "%d/%m/%Y", a.toString(), null, true));
            if (this.grid._dtmask_inc) {
                a = this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask || "%d/%m/%Y", this.cell.val);
            }
        }
        if (this.cell.val == "NaN" || this.cell.val == "Invalid Date") {
            this.cell._clearCell = true;
            this.cell.val = new Date();
            this.setCValue("&nbsp;", 0);
        }
        else {
            this.setCValue((a || "").toString(), this.cell.val);
        }
    };
    return eXcell_dhxCalendar;
})(eXcell);
window.eXcell_dhxCalendar = eXcell_dhxCalendar;
var eXcell_dhxCalendarA = (function (_super) {
    __extends(eXcell_dhxCalendarA, _super);
    function eXcell_dhxCalendarA(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
            if (!this.grid._grid_calendarA) {
                var e = (this.grid._grid_calendarA = new dhtmlxCalendarObject());
                this.grid.callEvent("onDhxCalendarCreated", [e]);
                var c = this.grid;
                e.attachEvent("onClick", function () {

                    this._last_operation_calendar = true;
                    window.setTimeout(function () {
                        c.editStop();
                    }, 1);
                    return true;
                });
                var g = function (h) {
                    (h || event).cancelBubble = true;
                };
                goingEvent(e.base, "click", g);
            }
        }
    }
    eXcell_dhxCalendarA.prototype.edit = function () {
        var c = this.grid.getPosition(this.cell);
        this.grid._grid_calendarA._show(false, false);
        this.grid._grid_calendarA.setPosition(c[0] * 1 + this.cell.offsetWidth, c[1] * 1);
        this.grid.callEvent("onCalendarShow", [
            this.grid._grid_calendarA,
            this.cell.parentNode.idd,
            this.cell._cellIndex
        ]);
        this.grid._grid_calendarA._last_operation_calendar = false;
        this.cell._cediton = true;
        this.val = this.cell.val;
        this._val = this.cell.innerHTML;
        var a = this.grid._grid_calendarA.draw;
        this.grid._grid_calendarA.draw = function () { };
        this.grid._grid_calendarA.setDateFormat(this.grid._dtmask || "%d/%m/%Y");
        this.grid._grid_calendarA.setDate(this.val);
        this.grid._grid_calendarA.draw = a;
        this.cell.atag =
            !this.grid.multiLine && (dhx4.isKHTML || dhx4.isMacOS || dhx4.isFF)
                ? "INPUT"
                : "TEXTAREA";
        this.obj = document.createElement(this.cell.atag);
        this.obj.style.height = this.cell.offsetHeight - 4 + "px";
        this.obj.className = "dhx_combo_edit";
        this.obj.wrap = "soft";
        this.obj.style.textAlign = this.cell.align;
        this.obj.onclick = function (g) {
            (g || event).cancelBubble = true;
        };
        this.obj.onmousedown = function (g) {
            (g || event).cancelBubble = true;
        };
        this.obj.value = this.getValue();
        this.cell.innerHTML = "";
        this.cell.appendChild(this.obj);
        if (window.dhx4.isIE) {
            this.obj.style.overflow = "visible";
            if (this.grid.multiLine &&
                this.obj.offsetHeight >= 18 &&
                this.obj.offsetHeight < 40) {
                this.obj.style.height = "36px";
                this.obj.style.overflow = "scroll";
            }
        }
        this.obj.onselectstart = function (g) {
            if (!g) {
                g = event;
            }
            g.cancelBubble = true;
            return true;
        };
        this.obj.focus();
        this.obj.focus();
    };
    eXcell_dhxCalendarA.prototype.getDate = function () {
        if (this.cell.val) {
            return this.cell.val;
        }
        return null;
    };
    eXcell_dhxCalendarA.prototype.getValue = function () {
        if (this.cell._clearCell) {
            return "";
        }
        if (this.grid._dtmask_inc && this.cell.val) {
            return this.grid._grid_calendarA
                .getFormatedDate(this.grid._dtmask_inc, this.cell.val)
                .toString();
        }
        return this.cell.innerHTML.toString()._dhx_trim();
    };
    eXcell_dhxCalendarA.prototype.detach = function () {
        if (!this.grid._grid_calendarA) {
            return;
        }
        this.grid._grid_calendarA.hide();
        if (this.cell._cediton) {
            this.cell._cediton = false;
        }
        else {
            return;
        }
        if (this.grid._grid_calendarA._last_operation_calendar) {
            this.grid._grid_calendarA._last_operation_calendar = false;
            var e = this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask || "%d/%m/%Y");
            var c = this.grid._grid_calendarA.getDate();
            this.cell.val = new Date(c);
            this.setCValue(e, c);
            this.cell._clearCell = !e;
            var a = this.val;
            this.val = this._val;
            return this.cell.val.valueOf() != (a || "").valueOf();
        }
        this.setValue(this.obj.value);
        var aVal = this.val;
        this.val = this._val;
        return this.cell.val.valueOf() != (aVal || "").valueOf();
    };
    eXcell_dhxCalendarA.prototype.setValue = function (a) {
        if (a && typeof a == "object") {
            this.cell.val = a;
            this.cell._clearCell = false;
            this.setCValue(this.grid._grid_calendarA
                .getFormatedDate(this.grid._dtmask || "%d/%m/%Y", a)
                .toString(), this.cell.val);
            return;
        }
        if (!a || a.toString()._dhx_trim() == "") {
            a = "&nbsp";
            this.cell._clearCell = true;
            this.cell.val = "";
        }
        else {
            this.cell._clearCell = false;
            this.cell.val = new Date(this.grid._grid_calendarA.setFormatedDate(this.grid._dtmask_inc || this.grid._dtmask || "%d/%m/%Y", a.toString(), null, true));
            if (this.grid._dtmask_inc) {
                a = this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask || "%d/%m/%Y", this.cell.val);
            }
        }
        if (this.cell.val == "NaN" || this.cell.val == "Invalid Date") {
            this.cell.val = new Date();
            this.cell._clearCell = true;
            this.setCValue("&nbsp;", 0);
        }
        else {
            this.setCValue((a || "").toString(), this.cell.val);
        }
    };
    return eXcell_dhxCalendarA;
})(eXcell);
window.eXcell_dhxCalendarA = eXcell_dhxCalendarA;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_dhxCalendar.js